module.exports = __webpack_public_path__ + "img/liberon_12s.7ae40479.jpg";